/* 🤖 this file was generated by svg-to-ts */
export const mgcIconPanoramasFilled: {
  name: 'panoramas-filled';
  data: string;
} = {
  name: 'panoramas-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.18 5.334a1.523 1.523 0 0 0-.935.658C1.989 6.391 2 6.117 2 12c0 4.697.007 5.372.062 5.581.175.671.76 1.11 1.478 1.111.294 0 .372-.02.96-.242 5.104-1.925 9.867-1.927 14.981-.008.709.266.927.307 1.262.238.442-.092.786-.32 1.012-.672.256-.399.245-.125.245-6.008 0-4.697-.007-5.372-.062-5.581-.174-.67-.763-1.113-1.478-1.113-.294 0-.371.02-.96.243-5.091 1.928-9.838 1.929-14.997.004-.7-.261-.983-.308-1.323-.219"/></svg>`
};
